import { useEffect, useRef } from "preact/hooks";
import { Redirect, useLocation } from "wouter-preact";
import { Composer } from "../components/Composer";
import { Disclaimer } from "../components/Disclaimer";
import { SidebarTrigger } from "../components/Sidebar";
import { TurnView } from "../components/TurnView";
import { resetConversation, turns } from "../state";

export function Chat() {
  const threadRef = useRef<HTMLDivElement>(null);
  const stickToBottom = useRef(true);
  const [, navigate] = useLocation();

  // Track whether the user is reading history or anchored to the latest turn.
  useEffect(() => {
    const el = threadRef.current;
    if (!el) return;
    const onScroll = () => {
      const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
      stickToBottom.current = distance < 96;
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  // Runs after every render, so it follows the stream without an explicit tick.
  useEffect(() => {
    const el = threadRef.current;
    if (el && stickToBottom.current) el.scrollTop = el.scrollHeight;
  });

  function newQuestion() {
    resetConversation();
    navigate("/ask");
  }

  if (turns.value.length === 0) return <Redirect to="/ask" />;

  return (
    <div class="view view--chat view--live">
      {
        /* No top bar: the controls float over the thread on pill backdrops, and
          the old header exists only as a drop shadow the content slides
          under. */
      }
      <div class="chat__shadow" aria-hidden="true" />
      <SidebarTrigger />
      <button
        type="button"
        class="btn btn--icon btn--ghost chat__new"
        onClick={newQuestion}
      >
        New
      </button>

      <div class="chat__thread" ref={threadRef}>
        <div class="chat__turns content">
          {turns.value.map((turn, index) => (
            <TurnView
              key={turn.id}
              turn={turn}
              isLast={index === turns.value.length - 1}
            />
          ))}
        </div>
        <Disclaimer />
      </div>

      <Composer />
    </div>
  );
}
